
  import { Vue, Component, Prop } from "vue-property-decorator";
  import imgA from "@/components/icons/employeeCardPlaceholders/imgA.vue";
  import imgB from "@/components/icons/employeeCardPlaceholders/imgB.vue";
  import imgC from "@/components/icons/employeeCardPlaceholders/imgC.vue";
  import imgD from "@/components/icons/employeeCardPlaceholders/imgD.vue";
  import imgE from "@/components/icons/employeeCardPlaceholders/imgE.vue";
  import imgF from "@/components/icons/employeeCardPlaceholders/imgF.vue";
  import imgG from "@/components/icons/employeeCardPlaceholders/imgG.vue";
  import imgH from "@/components/icons/employeeCardPlaceholders/imgH.vue";
  import imgI from "@/components/icons/employeeCardPlaceholders/imgI.vue";
  import imgJ from "@/components/icons/employeeCardPlaceholders/imgJ.vue";
  import imgK from "@/components/icons/employeeCardPlaceholders/imgK.vue";
  import imgL from "@/components/icons/employeeCardPlaceholders/imgL.vue";
  import imgM from "@/components/icons/employeeCardPlaceholders/imgM.vue";
  import imgN from "@/components/icons/employeeCardPlaceholders/imgN.vue";
  import imgO from "@/components/icons/employeeCardPlaceholders/imgO.vue";
  import imgP from "@/components/icons/employeeCardPlaceholders/imgP.vue";
  import imgQ from "@/components/icons/employeeCardPlaceholders/imgQ.vue";
  import imgR from "@/components/icons/employeeCardPlaceholders/imgR.vue";
  import imgS from "@/components/icons/employeeCardPlaceholders/imgS.vue";
  import imgT from "@/components/icons/employeeCardPlaceholders/imgT.vue";
  import imgU from "@/components/icons/employeeCardPlaceholders/imgU.vue";
  import imgV from "@/components/icons/employeeCardPlaceholders/imgV.vue";
  import imgW from "@/components/icons/employeeCardPlaceholders/imgW.vue";
  import imgX from "@/components/icons/employeeCardPlaceholders/imgX.vue";
  import imgY from "@/components/icons/employeeCardPlaceholders/imgY.vue";
  import imgZ from "@/components/icons/employeeCardPlaceholders/imgZ.vue";
  import getDefaultImageName from "@/helpers/getDefaultImageName";

  @Component({
    components: {
      imgA,
      imgB,
      imgC,
      imgD,
      imgE,
      imgF,
      imgG,
      imgH,
      imgI,
      imgJ,
      imgK,
      imgL,
      imgM,
      imgN,
      imgO,
      imgP,
      imgQ,
      imgR,
      imgS,
      imgT,
      imgU,
      imgV,
      imgW,
      imgX,
      imgY,
      imgZ,
    },
  })
  export default class DefaultCardImage extends Vue {
    @Prop({ type: String, required: true }) readonly givenName!: string;

    get defaultImageComponentName(): string {
      return getDefaultImageName(this.givenName);
    }
  }
